import { CreateFeeBlockTypes } from './types';

import cn from './tariffs.module.css';

const CreateFeeBlock = ({ children, title }: CreateFeeBlockTypes) => (
  <div className={cn.createFeeBlock}>
    {title && <div className={cn.createFeeBlockTitle}>{title}</div>}
    {children}
  </div>
);

export default CreateFeeBlock;
